import React from 'react';
import { Box } from '@mui/material';
import MapScope from './MapScope';

export default function ScopedFieldAgrilytics(props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: 1,
        paddingRight: '1.5rem',
      }}
    >
      <MapScope {...props} />
    </Box>
  );
}
